import { useDomain } from "../helpers/DomainContext";
import styles from "../styles/contact.module.css";

export function Contact() {
    const { showPersonalInfo } = useDomain();

    return (
        <div className={styles.contactContainer}>
            {showPersonalInfo && (
                <div className={styles.link}>
                    <a href="mailto:agoldman018@gmail.com" target="_blank">
                        agoldman018@gmail.com
                    </a>
                </div>
            )}
            {showPersonalInfo && (
                <div className={styles.link}>
                    <a
                        href="https://www.linkedin.com/in/ari-goldman/"
                        target="_blank"
                    >
                        LinkedIn
                    </a>
                </div>
            )}
            <div className={styles.link}>
                <a href="https://github.com/ari-goldman" target="_blank">
                    GitHub
                </a>
            </div>
            <div className={styles.link}>
                <a href="https://goobst.itch.io/" target="_blank">
                    itch.io
                </a>
            </div>
            <h2>
                <i>@goobst on discord</i>
            </h2>
        </div>
    );
}
